import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

import { environment } from "pstat-anywhere/relay";

const mutation = graphql`
  mutation LoginMutation(
    $username: String!
    $password: String!
    $cameFrom: String
  ) {
    login(username: $username, password: $password, cameFrom: $cameFrom) {
      ok
      reasons
      redirectUrl
    }
  }
`;

export const doLogin = (username, password, cameFrom, callback) => {
  const variables = {
    username: username,
    password: password,
    cameFrom: cameFrom
  };

  // TODO decide how to handle errors
  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => {
      callback(response);
    },
    onError: err => console.error(err)
  });
};
